import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import Store from '../../Store';
import { Select, SelectProps as Props } from '@mui/material';
import { OnChangeUnits } from '../_actions/DocumentActions';

const mapStateToProps = (store:Store, props:Props) => ({
	value: store.getIn(['create', 'document', 'units'])
});

const mapDispatchToProps = (dispatch:Dispatch, props:Props) => ({
	onChange: (e:any) => {dispatch(OnChangeUnits(e.target.value))}
});

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(Select);